module.exports = __webpack_public_path__ + "static/UNITY-Square-One-5th-floor-modern_v2-en-8a6b17f6eeba1ad0269125a52fdbf342.pdf";